<template>
  <section v-loading="loading">
    <div class="all-cases-view" id="all-physicians-listing">
      <div class="navbarComponent">
        <div class="container-sm-table">
          <div class="listings-navbar">
            <el-row>
              <el-col>
                <ul
                  class="d-flex flex-wrap justify-content-end list-items-group-15"
                >
                  <!-- <li>
                    <div class="form-element search-with-filter-input">
                      <el-select
                        v-model="searchBy"
                        clearable
                        filterable
                        default-first-option
                        :reserve-keyword="false"
                        placeholder="Select Search"
                        @change="clearInputSearch"
                      >
                        <el-option
                          v-for="item in searchOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                      <span class="search-icon">
                        <img
                          src="@/assets/images/icons/search-icon-with-bg-red.svg"
                          alt="icon"
                          class="img-fluid"
                        />
                      </span>
                    </div>
                  </li> -->
                  <li v-if="isSearchByInput">
                    <div class="form-element input-with-icon search-input-lg">
                      <el-input
                        placeholder="Search by name /NPI /phone/ fax"
                        v-model="search_string"
                        @input="getAutoCompleteCases()"
                        :clearable="true"
                      ></el-input>
                      <span>
                        <img
                          src="@/assets/images/icons/search-icon-with-bg-red.svg"
                          alt="icon"
                          class="img-fluid icon"
                        />
                      </span>
                    </div>
                  </li>
                  <li v-else-if="searchBy == 'fax'">
                    <div class="form-element input-with-icon search-input-lg">
                      <el-input
                        placeholder="Search"
                        v-model="search_fax"
                        @input="getAutoCompleteCases()"
                        :clearable="true"
                      ></el-input>
                      <span>
                        <img
                          src="@/assets/images/icons/search-icon-with-bg-red.svg"
                          alt="icon"
                          class="img-fluid icon"
                        />
                      </span>
                    </div>
                  </li>
                  <li v-else-if="searchBy == 'phone'">
                    <div class="form-element input-with-icon search-input-lg">
                      <el-input
                        placeholder="Search"
                        v-model="search_phone"
                        @input="getAutoCompleteCases()"
                        :clearable="true"
                      ></el-input>
                      <span>
                        <img
                          src="@/assets/images/icons/search-icon-with-bg-red.svg"
                          alt="icon"
                          class="img-fluid icon"
                        />
                      </span>
                    </div>
                  </li>
                  <li v-else-if="searchBy == 'specializations'">
                    <div class="form-element input-with-icon search-input-lg">
                      <el-input
                        placeholder="Search"
                        v-model="search_specializations"
                        @input="getAutoCompleteCases()"
                        :clearable="true"
                      ></el-input>
                      <span>
                        <img
                          src="@/assets/images/icons/search-icon-with-bg-red.svg"
                          alt="icon"
                          class="img-fluid icon"
                        />
                      </span>
                    </div>
                  </li>
                </ul>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="container-sm-table" style="padding-top: 0">
        <div class="primary-content-view-new">
          <div
            class="listings listings__table listings__all-cases"
            id="all-cases-listings"
          >
            <el-table
              :data="physiciansData.data"
              height="calc(100vh - 215px)"
              :default-sort="{
                prop: orderBy,
                order: orderType == 'asc' ? 'ascending' : 'descending',
              }"
              @sort-change="onChangeSort"
            >
              <el-table-column
                prop="name"
                label="PHYSICIAN"
                min-width="180"
                sortable="custom"
                fixed="left"
                ><template v-slot="scope"
                  ><span class="cursor" @click="onView(scope.row)">{{
                      scope.row.first_name
                        ? convertToUppercase(scope.row.first_name) + " " + convertToUppercase(scope.row.last_name)
                        : "--"
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="npi"
                label="NPI NUMBER"
                width="120"
                sortable="custom"
              >
              </el-table-column>
              <el-table-column
                prop="specialization"
                label="SPECIALIZATIONS"
                min-width="350"
                sortable="custom"
              >
                <template v-slot="scope">
                  <span class="table_cell-ellipsis">
                    {{
                      scope.row.specialization &&
                      scope.row.specialization.length
                        ? scope.row.specialization.toUpperCase()
                        : "--"
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="phone_number"
                label="PHONE NO"
                width="140"
                sortable="custom"
              >
              </el-table-column>
              <el-table-column
                prop="fax"
                label="FAX"
                width="140"
                sortable="custom"
              ></el-table-column>
              <el-table-column prop="status" label="STATUS" width="140">
                <template #default="scope">
                  <div class="column-status cursor" v-if="scope.row.status">
                    <el-dropdown
                      class="status-dropdown"
                    >
                      <span class="el-dropdown-link">
                        <el-tag :type="getStatusType(scope.row.status)">{{
                          scope.row.status.split("_").join(" ")
                        }}</el-tag>
                      </span>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="physicians-pagination">
          <div class="listings listings__pagination">
            <el-pagination
              v-model:currentPage="page"
              v-model:page-size="pageSize"
              :page-sizes="[25, 50, 75, 100]"
              layout="prev, pager, next, jumper, sizes, total"
              :total="physiciansData.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import { physiciansSearchOptions } from "@/config/constants/searchConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import FilterHelper from "@/mixins/FilterHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      searchBy: "",
      search_string: "",
      searchOptions: physiciansSearchOptions,
      page: 1,
      pageSize: 25,
      loading: false,
      orderBy: "created_at",
      orderType: "desc",
      searchByKey: ["name", "npi_code"],
      search_fax: "",
      search_phone: "",
      search_specializations: "",
      physiciansData: {},
    };
  },
  props: {
    selectedStatuses: {
      default: [],
    },
  },
  mixins: [UserPermissionsHelper, FilterHelper],
  computed: {
    ...mapGetters("physicians", [
      "getAllPhysicians",
      "getPhysicianStatusUpdate",
    ]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    isSearchByInput() {
      return true;
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "success";
        } else if (status == "INACTIVE") {
          return "danger";
        } else {
          return "default";
        }
      };
    },
  },
  async mounted() {
    this.loading = true;
    this.setQueryParamsData();
    await this.fetchPhysiciansList();
    this.loading = false;
  },
  methods: {
    clearInputSearch() {
      if (
        this.search_string ||
        this.search_fax ||
        this.search_phone ||
        this.search_specializations
      ) {
        this.isSearchByInput = "";
        this.search_string = "";
        this.search_fax = "";
        this.search_phone = "";
        this.search_specializations = "";
        this.page = 1;
        this.fetchPhysiciansList(1);
      }
    },
    getAutoCompleteCases() {
      setTimeout(() => {
        this.page = 1;
        this.fetchPhysiciansList();
      }, 600);
    },
    setQueryParamsData() {
      if (this.$route.query) {
        this.page = this.$route.query.selectedPhysicianPage
          ? parseInt(this.$route.query.selectedPhysicianPage)
          : 1;
        this.pageSize = this.$route.query.selectedPhysicianPageSize
          ? parseInt(this.$route.query.selectedPhysicianPageSize)
          : 25;
        if (this.$route.query.selectedPhysicianString) {
          this.search_string = this.$route.query.selectedPhysicianString;
        }
        if (this.$route.query.selectedPhysicianSearchBy) {
          this.searchBy = this.$route.query.selectedPhysicianSearchBy;
        }
        if (this.$route.query.selectedPhysicianFax) {
          this.search_fax = this.$route.query.selectedPhysicianFax;
        }
        if (this.$route.query.selectedPhysicianPhone) {
          this.search_phone = this.$route.query.selectedPhysicianPhone;
        }
        if (this.$route.query.selectedPhysicianOrderBy) {
          this.orderBy = this.$route.query.selectedPhysicianOrderBy;
        }
        if (this.$route.query.selectedPhysicianOrderType) {
          this.orderType = this.$route.query.selectedPhysicianOrderType;
        }
        if (this.$route.query.selectedPhysicianSpecializations) {
          this.search_specializations =
            this.$route.query.selectedPhysicianSpecializations;
        }
      }
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "created_at";
        this.orderType = "desc";
      }
      this.fetchPhysiciansList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchPhysiciansList();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchPhysiciansList();
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
      };
      if (this.orderBy && this.orderType) {
        params.sort_by = this.orderBy;
        params.sort_order = this.orderType;
      }
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.search_fax) {
        params.fax = this.search_fax;
      }
      if (this.search_phone) {
        params.phone = this.search_phone;
      }
      if (this.search_specializations) {
        params.specializations = this.search_specializations;
      }
      params.status = this.selectedStatuses;
      return params;
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedPhysicianPage: params.page,
        selectedPhysicianHospital: params.hospital,
        selectedPhysicianDateOfBirth: params.date_of_birth,
        selectedPhysician: params.ordering_physician,
        selectedPhysicianString: params.search_string,
        selectedPhysicianFax: params.fax,
        selectedPhysicianPhone: params.phone,
        selectedPhysicianOrderBy: params.sort_by,
        selectedPhysicianOrderType: params.sort_order,
        selectedPhysicianSpecializations: params.specializations,
        selectedPhysicianPageSize: params.limit,
        selectedPhysicianSearchBy: this.searchBy || undefined,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    async fetchPhysiciansList() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
        this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss">
.listings__all-cases {
  .el-button {
    min-height: 30px;
    padding: 0;
    background: none;
    border: none;
  }
}
.stickyNavbar {
  padding-bottom: 5px !important;
  .container-sm-table {
    padding-top: 0;
    padding-bottom: 5px;
  }
}
.search {
  width: 10px;
  height: 10px;
}
// physician list end
</style>
